export default __webpack_public_path__ + "static/media/upload_icon.e7e38772.svg";